module.exports = __webpack_public_path__ + "img/ios.6eec5833.png";